import { FormInstance } from 'antd'
import { ReportFilter, ReportMetadata, ReportRequestParametersObjectObject } from 'common/api/api.ts'
import { reportApi } from 'common/api/entitiesApi.tsx'
import { useEffect, useState } from 'react'
import { ReportColumnOption } from './types.ts'

const sortByTitle = <T extends { title?: string }>(items: T[]) =>
  [...items].sort((left, right) => ((left.title || '') < (right.title || '') ? -1 : 1))

export const useReportMetadata = (
  reportType: ReportRequestParametersObjectObject.TypeEnum,
  form: FormInstance,
  timezoneId?: string,
) => {
  const [metadataLoaded, setMetadataLoaded] = useState(false)
  const [allFilters, setAllFilters] = useState<ReportFilter[]>([])
  const [reportKeys, setReportKeys] = useState<ReportColumnOption[]>([])
  const [reportValues, setReportValues] = useState<ReportColumnOption[]>([])

  useEffect(() => {
    let cancelled = false
    setMetadataLoaded(false)

    reportApi.metadata(reportType as unknown as string).then((metadata: ReportMetadata) => {
      if (cancelled) {
        return
      }

      setAllFilters(sortByTitle(metadata.filters || []))
      setReportKeys(sortByTitle(metadata.keys || []))
      setReportValues(sortByTitle(metadata.values || []))

      if (!form.getFieldValue('timezone') && timezoneId) {
        form.setFieldsValue({ timezone: timezoneId })
      }

      setMetadataLoaded(true)
    })

    return () => {
      cancelled = true
    }
  }, [reportType, form, timezoneId])

  return {
    metadataLoaded,
    allFilters,
    reportKeys,
    reportValues,
  } as const
}
